import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { InfineScrollLoaderService } from './services/infine-scroll-loader.service';
import { FollowersCountPipe } from './pipes/followers-count.pipe';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { NgModule, ErrorHandler } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FooterComponent } from "../core/footer/footer.component";
import { BreadcrumComponent } from '../core/breadcrum/breadcrum.component';
import { LeftNavMenuComponent } from "../core/left-nav-menu/left-nav-menu.component";
import { TopNavBarComponent } from "../core/top-nav-bar/top-nav-bar.component";
import { PageNotFoundComponent } from "../feature/external/page-not-found/page-not-found.component";
import { PublicPageComponent } from "../feature/external/public-page/public-page.component";
import { RouterModule } from "@angular/router";

import { DisplayLoaderDirective } from "./directives/display-loader.directive";
import { Ng2TelInputModule } from "ng2-tel-input";
import { UserVerificationService } from "./services/user-verification.service";
import { RoutingGuardService } from "./services/routing-guard.service";
import { HomeRoutingGuardService } from "@app/shared/services/Home-guard.service";
import { TermsComponent } from "@app/feature/external/terms/terms.component";
import { ChangePasswordComponent } from "@app/shared/components/change-password/change-password.component";

import { MasterDataService } from "@shared/services/master-data.service";
import { RolesNavTopBarComponent } from "./core/roles-nav-top-bar/roles-nav-top-bar.component";
import { FilterUtilService } from "@app/shared/services/filter-util.service";
import { OtpVerificationComponent } from "./components/otp-verification/otp-verification.component";
import { ChatBotIconComponent } from "@app/feature/main/roles-shared/chat-bot-icon/chat-bot-icon.component";
import { PaginatorModule } from "primeng/paginator";
import { RatingModule } from "ngx-rating";
import { httpInterceptorProviders } from "@shared/http-interceptors/index";
import { TechAnalystProfileComponent } from "./components/tech-analyst-profile/tech-analyst-profile.component";
import { RolesSharedModule } from "@app/feature/main/roles-shared/roles-shared.module";

import { NickNameModalService } from "@app/feature/main/roles-shared/services/nick-name-modal.service";
import { NickNameComponent } from "@app/feature/main/roles-shared/components/nick-name/nick-name.component";
import { TechAnalystPublicReportsComponent } from "./components/tech-analyst-public-reports/tech-analyst-public-reports.component";
import { TechAnalystPublicUpcomingReportsComponent } from "./components/tech-analyst-public-upcoming-reports/tech-analyst-public-upcoming-reports.component";
import { CommentComponent } from "./components/comment/comment.component";
import { ChoosepaymentModalComponent } from "./components/choosepayment-modal/choosepayment-modal.component";
import { LikesComponent } from "./components/likes/likes.component";
import { CommentMentionPipe } from "@app/feature/main/roles-shared/comment-mention.pipe";
import { CommentModalComponent } from "./components/comment-modal/comment-modal.component";
import { LikeModalComponent } from "./components/like-modal/like-modal.component";
import { CommentModalService } from "@app/shared/services/comment-modal.service";
import { MixpanelEventLoggingService } from "@app/shared/services/mixpanel-event-logging.service";
import { SortByPipe } from "@app/shared/pipes/sort-by.pipe";
import { ScheduleCallComponent } from "@app/shared/components/schedule-call/schedule-call.component";
import { CalendarModule } from 'primeng/calendar';
import { AppointmentService } from '@app/shared/services/appointment.service';
import { BsDatepickerModule, PopoverModule } from 'ngx-bootstrap';
import { ScheduleTimeZonePipe } from '@app/shared/pipes/schedule-time-zone.pipe';
import { ScheduleCallListComponent } from '@app/shared/components/schedule-call-list/schedule-call-list.component';
import { DurationPipe } from '@app/shared/pipes/duration.pipe';
import { TokboxModule } from '@app/tokbox/tokbox.module';
import { PrivacyPolicyComponent } from '@app/feature/external/privacy-policy/privacy-policy.component';
import { OwlModule } from 'ngx-owl-carousel';
import { ConnectMiniProfileComponent } from '@app/shared/components/connect-mini-profile/connect-mini-profile.component';
import { ConnectService } from '@app/shared/services/connect.service';
import { NameLetterPipe } from '@app/shared/pipes/name-letter.pipe';
import { RemoveConnectionComponent } from '@app/shared/components/remove-connection/remove-connection.component';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { VgBufferingModule } from 'videogular2/buffering';
import { FilterPipe } from '@app/shared/pipes/filter.pipe';
import { AnotationModule } from '@app/anotation/anotation.module';
import { MentionModule } from 'angular-mentions/mention';
import { CommentService } from '@app/shared/services/comment.service';

import { RightSideMenuBarComponent } from '@app/shared/components/right-side-menu-bar/right-side-menu-bar.component';
import { ShowAuthedDirective } from '@app/shared/directives/show-authed.directive';
import { MessageTimeZonePipe } from '@app/shared/pipes/message-time-zone.pipe';
import { MomentModule } from 'ngx-moment';
import { LinkShareComponent } from '@app/shared/components/link-share/link-share.component';
import { ShareModule, ShareButtonsOptions } from '@ngx-share/core';
import { ShareButtonsModule } from '@ngx-share/buttons';
import { AgmCoreModule } from '@agm/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { environment } from '@env/environment';
import { CustomFormsModule } from 'ng2-validation';
import { WhiteSpaceValidator } from '@app/shared/directives/whitespace-validator.directive';
import { TechAnalystScheduleService } from '@app/feature/main/tech-analyst/shared/services/tech-analyst-schedule.service';
import { Title, Meta } from '@angular/platform-browser';
import { NicknamePipe } from '@app/shared/pipes/nickname.pipe';
import { NgRedux, NgReduxModule } from '@angular-redux/store';
import { IAppState, rootReducer, INITIAL_STATE } from "@app/stateManagement/state.ts"
import { InfinitescrollDirective } from '@app/shared/directives/infinitescroll.directive';
import { RemoveHtmlTagsPipe } from './pipes/remove-html-tags.pipe';
import { AmountConverterPipe } from './pipes/amount-converter.pipe';
import { ScheduleCallProfileDetailsComponent } from './components/schedule-call-profile-details/schedule-call-profile-details.component';
import { MessageProfileDetailsComponent } from './components/message-profile-details/message-profile-details.component';
import { CommentsPipe } from './pipes/comments.pipe';
import { LikesPipe } from './pipes/likes.pipe';
import { RepliesPipe } from './pipes/replies.pipe';
import { BreadcrumService } from '@app/shared/services/breadcrum.service';
import { MultiSelectCustomComponent } from '@app/shared/components/multi-select-custom/multi-select-custom.component';
import { GroupedByPipe } from '@app/shared/pipes/grouped-by.pipe';
import { MultiSelectPipe } from '@app/shared/pipes/multi-select.pipe';
import { GeographicResponsibilityService } from './services/geographic-responsibility.service';
import {MultiSelectModule} from 'primeng/multiselect';
import { CustomMutliSelectDropdownComponent } from '@app/shared/components/custom-mutli-select-dropdown/custom-mutli-select-dropdown.component';
import { DomainFilterPipe } from '@app/shared/pipes/domain-filter.pipe';
import { LikeModalServiceService } from '@app/shared/services/like-modal-service.service';
import { HubSpotFormComponent } from '@app/feature/external/hub-spot-form/hub-spot-form.component';
import { CompleteProfileComponent } from './components/complete-profile/complete-profile.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import { TechVendorService } from '@app/feature/main/tech-vendor/shared/services/tech-vendor.service';
import { PriceFormatPipe } from './pipes/price-format.pipe';


const customOptions: ShareButtonsOptions = {
  twitterAccount: 'ecosystm360'
};
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpModule,
    Ng2TelInputModule,
    FormsModule,
    ReactiveFormsModule,
    PaginatorModule,
    RatingModule,
    CalendarModule,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    TokboxModule,
    OwlModule,
    BsDatepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    AnotationModule,
    MentionModule,
    MomentModule,
    ShareModule.forRoot(),
    AngularMultiSelectModule,
    ImageCropperModule,
    NguiAutoCompleteModule,
    ShareButtonsModule.forRoot({ options: customOptions }),
    AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_MAP_KEY
    }),
    InfiniteScrollModule,
    CustomFormsModule,
    NgReduxModule,
    MultiSelectModule,
    MatExpansionModule,
    MatIconModule
  ],
  declarations: [
    FooterComponent,
    BreadcrumComponent,
    LeftNavMenuComponent,
    TopNavBarComponent,
    PublicPageComponent,
    HubSpotFormComponent,
    PageNotFoundComponent,
    TermsComponent,
    DisplayLoaderDirective,
    ChangePasswordComponent,
    RolesNavTopBarComponent,
    OtpVerificationComponent,
    CompleteProfileComponent,
    ChatBotIconComponent,
    TechAnalystProfileComponent,
    NickNameComponent,
    TechAnalystPublicReportsComponent,
    TechAnalystPublicUpcomingReportsComponent,
    CommentComponent,
    ChoosepaymentModalComponent,
    LikesComponent,
    CommentMentionPipe,
    CommentModalComponent,
    LikeModalComponent,
    SortByPipe,
    ScheduleCallComponent,
    ScheduleTimeZonePipe,
    ScheduleCallListComponent,
    DurationPipe,
    PrivacyPolicyComponent,
    ConnectMiniProfileComponent,
    NameLetterPipe,
    RemoveConnectionComponent,
    FilterPipe,
    RightSideMenuBarComponent,
    ShowAuthedDirective,
    MessageTimeZonePipe,
    LinkShareComponent,
    WhiteSpaceValidator,
    NicknamePipe,
    InfinitescrollDirective,
    FollowersCountPipe,
    RemoveHtmlTagsPipe,
    AmountConverterPipe,
    ScheduleCallProfileDetailsComponent,
    MessageProfileDetailsComponent,
    CommentsPipe,
    LikesPipe,
    RepliesPipe,
    MultiSelectCustomComponent,
    GroupedByPipe,
    MultiSelectPipe,
    CustomMutliSelectDropdownComponent,
    DomainFilterPipe,
    CompleteProfileComponent,
    PriceFormatPipe
  ],
  exports: [
    DisplayLoaderDirective,
    FooterComponent,
    BreadcrumComponent,
    LeftNavMenuComponent,
    TopNavBarComponent,
    PublicPageComponent,
    HubSpotFormComponent,
    PageNotFoundComponent,
    RouterModule,
    HttpModule,
    Ng2TelInputModule,
    ChangePasswordComponent,
    RolesNavTopBarComponent,
    OtpVerificationComponent,
    CompleteProfileComponent,
    ImageCropperModule,
    ChatBotIconComponent,
    PaginatorModule,
    RatingModule,
    NickNameComponent,
    CommentMentionPipe,
    CommentComponent,
    ChoosepaymentModalComponent,
    LikesComponent,
    SortByPipe,
    FormsModule,
    ReactiveFormsModule,
    CommentModalComponent,
    LikeModalComponent,
    ScheduleCallComponent,
    CalendarModule,
    ScheduleTimeZonePipe,
    ScheduleCallListComponent,
    DurationPipe,
    PrivacyPolicyComponent,
    BsDatepickerModule,
    OwlModule,
    ConnectMiniProfileComponent,
    NameLetterPipe,
    RemoveConnectionComponent,
    BsDatepickerModule,
    FilterPipe,
    MentionModule,
    RightSideMenuBarComponent,
    ShowAuthedDirective,
    MessageTimeZonePipe,
    MomentModule,
    LinkShareComponent,
    ShareModule,
    ShareButtonsModule,
    AgmCoreModule,
    InfiniteScrollModule,
    CustomFormsModule,
    WhiteSpaceValidator,
    NicknamePipe,
    NgReduxModule,
    NicknamePipe,
    CommentsPipe,
    LikesPipe,
    RepliesPipe,
    InfinitescrollDirective,
    FollowersCountPipe,
    AngularMultiSelectModule,
    RemoveHtmlTagsPipe,
    AmountConverterPipe,
    ScheduleCallProfileDetailsComponent,
    MessageProfileDetailsComponent,
    MultiSelectCustomComponent,
    GroupedByPipe,
    MultiSelectPipe,
    CustomMutliSelectDropdownComponent,
    DomainFilterPipe,
    PopoverModule,
    PriceFormatPipe
  ],
  providers: [
    httpInterceptorProviders,
    UserVerificationService,
    RoutingGuardService,
    BreadcrumService,
    HomeRoutingGuardService,
    MasterDataService,
    FilterUtilService,
    NickNameModalService,
    CommentModalService,
    LikeModalServiceService,
    MixpanelEventLoggingService,
    AppointmentService,
    ConnectService,
    CommentService,
    TechAnalystScheduleService,
    Title,
    Meta,
    InfineScrollLoaderService,
    MultiSelectPipe,
    GeographicResponsibilityService,
    TechVendorService
  ]
})
export class AppSharedModule {
  constructor(ngRedux: NgRedux<IAppState>) {
    ngRedux.configureStore(rootReducer, INITIAL_STATE);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/app-shared.module.ts